import { render, staticRenderFns } from "./BlackMicropoint.vue?vue&type=template&id=7b6c7488&scoped=true"
import script from "./BlackMicropoint.vue?vue&type=script&lang=js"
export * from "./BlackMicropoint.vue?vue&type=script&lang=js"
import style0 from "./BlackMicropoint.vue?vue&type=style&index=0&id=7b6c7488&prod&scoped=true&lang=scss"
import style1 from "./BlackMicropoint.vue?vue&type=style&index=1&id=7b6c7488&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6c7488",
  null
  
)

export default component.exports